/**
 * @generated SignedSource<<5afa903b77b6244a1aa2ec9b3e94ab53>>
 * @relayHash 2a6d3b6565088b774bad70b364b139c8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 782a473dfec90098d6425dcff4ef38b354db9a1cc0ae4c3ea9309997887128c7

import type { ConcreteRequest } from 'relay-runtime';
export type useListLabelsDataSpaceIdQuery$variables = {
  spaceKey?: string | null;
};
export type useListLabelsDataSpaceIdQuery$data = {
  readonly space: {
    readonly id: string | null;
  } | null;
};
export type useListLabelsDataSpaceIdQuery = {
  response: useListLabelsDataSpaceIdQuery$data;
  variables: useListLabelsDataSpaceIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useListLabelsDataSpaceIdQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useListLabelsDataSpaceIdQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2a6d3b6565088b774bad70b364b139c8",
    "id": "782a473dfec90098d6425dcff4ef38b354db9a1cc0ae4c3ea9309997887128c7",
    "metadata": {},
    "name": "useListLabelsDataSpaceIdQuery",
    "operationKind": "query",
    "text": "query useListLabelsDataSpaceIdQuery($spaceKey:String){space(key:$spaceKey){id}}"
  }
};
})();

(node as any).hash = "b3935b747e8f02e00f6883bc6979f007";

export default node;
